import { NavLink as RouterNavLink, useLocation } from "react-router-dom";

const NavLink = ({ children, to = "#", end = false, className = "" }) => {
  const location = useLocation();

  const handleClick = () => {
    if (location.pathname === to) {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "auto",
      });
    }
  };

  return (
    <RouterNavLink
      to={to}
      end={end}
      onClick={handleClick}
      className={({ isActive }) =>
        [
          "text-[15px] transition-colors duration-200",
          isActive
            ? "text-black font-medium"
            : "text-[#6D6D6D] hover:text-black",
          className,
        ].join(" ")
      }
    >
      {children}
    </RouterNavLink>
  );
};

export default NavLink;